//  Сервис за управување со барања и известувања
import api from "@/api";
import { getUser } from "./db";

/* Клучеви во localStorage */
const LS_KEY = "baranja"; // сите барања
const YEAR_KEY = "baranja_year_counters"; // бројач на барања по година
const NOTIF_KEY = "izvestuvanja"; // сите известувања

/* Помошни функции за читање/запишување */
function readAll() {
  try {
    return JSON.parse(localStorage.getItem(LS_KEY) || "[]");
  } catch {
    return [];
  }
}

export function writeAll(list) {
  try {
    localStorage.setItem(LS_KEY, JSON.stringify(list));
  } catch (e) {
    console.error("Грешка при запишување барања:", e);
  }
}

function readYearCounters() {
  try {
    return JSON.parse(localStorage.getItem(YEAR_KEY) || "{}");
  } catch {
    return {};
  }
}

function writeYearCounters(obj) {
  localStorage.setItem(YEAR_KEY, JSON.stringify(obj));
}

/* Денешен датум dd.MM.yyyy */
function todayDate() {
  const d = new Date();
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();

  return `${dd}.${mm}.${yyyy}`;
}

/* Генерирање локален број за frontend */
function generateNextId() {
  const god = new Date().getFullYear().toString();
  const counters = readYearCounters();

  if (!counters[god]) counters[god] = 1;

  const list = readAll();
  let nextNum = counters[god];

  while (
    list.find(
      (b) => b.broj === `${String(nextNum).padStart(3, "0")}/${god}`
    )
  ) {
    nextNum++;
  }

  counters[god] = nextNum + 1;
  writeYearCounters(counters);

  const brojDisplay = `${String(nextNum).padStart(3, "0")}/${god}`;

  return {
    id: brojDisplay,
    year: Number(god),
    number: nextNum,
  };
}

/* Известувања */
function readNotifs() {
  try {
    return JSON.parse(localStorage.getItem(NOTIF_KEY) || "[]");
  } catch {
    return [];
  }
}

function writeNotifs(list) {
  localStorage.setItem(NOTIF_KEY, JSON.stringify(list));
}

export function dodadiIzvestuvanje(opis, email) {
  const list = readNotifs();

  const notif = {
    id: Date.now(),
    email,
    title: opis,
    date: todayDate(),
    status: "Непрочитано",
  };

  list.unshift(notif);
  writeNotifs(list);
}

export function getIzvestuvanjaZaKorisnik(email) {
  return readNotifs().filter((x) => x.email === email);
}

export function oznaciKaoProcitano(id) {
  const list = readNotifs();
  const i = list.findIndex((x) => x.id === id);

  if (i !== -1) {
    list[i].status = "Прочитано";
    writeNotifs(list);
  }
}

/* Додавање ново барање */
export async function dodadiBaranje(baranjeObj) {
  console.log("baranjeObj од NovoBaranje:", baranjeObj);

  const user = getUser() || {};

  const partnerID = Number(
    baranjeObj.PartnerID ||
      baranjeObj.partnerID ||
      user.PartnerID ||
      user.PartnerId ||
      user.partnerID ||
      user.partnerId ||
      user.Id ||
      user.id ||
      0
  );

  const firma =
    baranjeObj.Firma ||
    baranjeObj.firma ||
    user.Firma ||
    user.firma ||
    user.NazivFirma ||
    user.nazivFirma ||
    user.NazivPartner ||
    user.nazivPartner ||
    user.PartnerNaziv ||
    user.partnerNaziv ||
    user.Company ||
    user.company ||
    "-";

  const email =
    baranjeObj.Email ||
    baranjeObj.email ||
    baranjeObj.klientEmail ||
    user.Email ||
    user.email ||
    user.EMail ||
    user.eMail ||
    user.Eposta ||
    user.eposta ||
    user.Mail ||
    user.mail ||
    "-";

  const baratel =
    baranjeObj.Baratel ||
    baranjeObj.baratel ||
    user.username ||
    email ||
    "-";

  const opis = baranjeObj.Opis || baranjeObj.opis || "-";

  const aplikacijaID = Number(
    baranjeObj.AplikacijaID ||
      baranjeObj.aplikacijaID ||
      baranjeObj.aplikacija ||
      0
  );

  const aplikacijaOpis =
    baranjeObj.AplikacijaOpis ||
    baranjeObj.aplikacijaOpis ||
    baranjeObj.OpisAplikacija ||
    baranjeObj.aplikacijaNaziv ||
    "-";

  const stepenItnost = Number(
    baranjeObj.StepenItnost ||
      baranjeObj.stepenItnost ||
      baranjeObj.stepen ||
      0
  );

  const prioritet =
    baranjeObj.Prioritet ||
    baranjeObj.prioritet ||
    "-";

  const oddel =
    baranjeObj.Oddel ||
    baranjeObj.oddel ||
    "servis";

  const files = Array.isArray(baranjeObj.Files)
    ? baranjeObj.Files
    : Array.isArray(baranjeObj.sliki)
    ? baranjeObj.sliki
    : [];

  if (!partnerID) {
    throw new Error("Недостасува PartnerID.");
  }

  if (!baratel || !opis || !stepenItnost || !aplikacijaID) {
    throw new Error("Недостасуваат задолжителни полиња.");
  }

  const payload = {
    PartnerID: partnerID,
    List: [
      {
        Baratel: baratel,
        AplikacijaID: aplikacijaID,
        AplikacijaOpis: aplikacijaOpis,
        Opis: opis,
        StepenItnost: stepenItnost,
        Prioritet: prioritet,
        Firma: firma,
        Email: email,
        Oddel: oddel,

        VrabIDCreate: Number(
          user.VrabID ||
            user.VrabId ||
            user.vrabID ||
            user.vrabId ||
            user.UserID ||
            user.userID ||
            user.Id ||
            user.id ||
            0
        ),

        Files: files.map((f) => ({
          Fajl: f.Fajl || f.base64,
          FileName: f.FileName || f.name,
        })),
      },
    ],
  };

  console.log("payload што оди кон backend:", payload);
  console.log("payload List[0] за mail:", payload.List[0]);

  /*
    ВАЖНО:
    Ова е единственото место каде што треба да има api.post("/baranja/add").
    Во NovoBaranje.vue не смее да има втор api.post("/baranja/add"),
    затоа што тогаш стигаат два mail-а.
  */
  // const res = await api.post("/baranja/add", payload, {
  //   headers: {
  //     "Content-Type": "application/json",
  //   },
  // });

  //console.log("одговор од backend:", res.data);

  /*
    Локално снимање за постоечките frontend прегледи.
    Ова не праќа mail. Само го чува барањето во localStorage.
  */
  const { id, year, number } = generateNextId();
  const list = readAll();

  const lokalnoBaranje = {
    id,
    broj: id,
    year,
    number,
    datum: todayDate(),
    createdAtISO: new Date().toISOString(),

    naslov: `[${firma}] ${baratel} - ${aplikacijaOpis || aplikacijaID}`,

    // стари имиња за постоечки frontend
    opis: opis,
    stepen: stepenItnost,
    baratel: baratel,
    aplikacija: aplikacijaID,
    aplikacijaOpis: aplikacijaOpis,
    firma: firma,
    prioritet: prioritet,
    klientEmail: email,
    oddel: oddel,

    // нови имиња како backend/mail
    Opis: opis,
    StepenItnost: stepenItnost,
    Baratel: baratel,
    AplikacijaID: aplikacijaID,
    AplikacijaOpis: aplikacijaOpis,
    Firma: firma,
    Prioritet: prioritet,
    Email: email,
    Oddel: oddel,

    sliki: files,

    tip: baranjeObj.tip || "Друго",
    status: "Отворено",
    vraboten: null,
    casovi: 0,
    fazi: [],
    notes: "",

    history: [
      {
        action: "Создадено барање",
        date: new Date().toLocaleString("mk-MK"),
        details: `Барањето е поднесено од ${email}.`,
      },
    ],
  };

  list.push(lokalnoBaranje);
  writeAll(list);

  dodadiIzvestuvanje(`Барањето ${id} е успешно поднесено.`, email);

  return lokalnoBaranje;
}

/* Преземање */
export function getBaranjaZaKorisnik(email) {
  return readAll().filter((x) => x.klientEmail === email);
}

export function getSiteBaranja() {
  return readAll();
}

export function getBaranjePoId(id) {
  return readAll().find((x) => x.id === id) || null;
}

export function getBaranjeByIdOrBroj(idOrBroj) {
  const list = readAll();

  return list.find((x) => x.id === idOrBroj || x.broj === idOrBroj) || null;
}

export function getBaranjaZaNajavenKlient() {
  const user = getUser();

  if (!user || !user.email) return [];

  return getBaranjaZaKorisnik(user.email);
}

/* Ажурирања */
export function updateBaranje(updatedBaranje) {
  const list = readAll();
  const index = list.findIndex((b) => b.id === updatedBaranje.id);

  if (index === -1) return false;

  const old = list[index];

  if (updatedBaranje.fazi && updatedBaranje.fazi.length) {
    const totalCasovi = updatedBaranje.fazi.reduce(
      (sum, f) => sum + (Number(f.casovi) || 0),
      0
    );

    updatedBaranje.casovi = totalCasovi;

    const allDone = updatedBaranje.fazi.every((f) => f.status === "Завршено");

    if (allDone) {
      updatedBaranje.status = "Завршено";
    } else if (updatedBaranje.fazi.some((f) => f.status === "Во тек")) {
      updatedBaranje.status = "Во тек";
    }
  }

  const historyItem = {
    action: "Ажурирано барање",
    date: new Date().toLocaleString("mk-MK"),
    details: "Барањето е изменето.",
  };

  updatedBaranje.history = [...(old.history || []), historyItem];

  list[index] = {
    ...old,
    ...updatedBaranje,
  };

  writeAll(list);

  if (list[index].klientEmail) {
    dodadiIzvestuvanje(
      `Барањето ${list[index].id} е ажурирано.`,
      list[index].klientEmail
    );
  }

  return true;
}

/* Статус и доделување */
export function promeniStatus(id, novStatus) {
  const list = readAll();
  const i = list.findIndex((x) => x.id === id);

  if (i === -1) return;

  const star = list[i].status;

  list[i].status = novStatus;
  list[i].history = list[i].history || [];

  list[i].history.push({
    action: "Промена на статус",
    date: new Date().toLocaleString("mk-MK"),
    details: `Од "${star}" во "${novStatus}".`,
  });

  dodadiIzvestuvanje(
    `Статусот на вашето барање ${list[i].id} е променет на "${novStatus}".`,
    list[i].klientEmail
  );

  writeAll(list);
}

export function dodeliVraboten(id, ime) {
  const list = readAll();
  const i = list.findIndex((x) => x.id === id);

  if (i === -1) return;

  list[i].vraboten = ime;
  list[i].history = list[i].history || [];

  list[i].history.push({
    action: "Доделен вработен",
    date: new Date().toLocaleString("mk-MK"),
    details: `Барањето е доделено на ${ime}.`,
  });

  dodadiIzvestuvanje(
    `Барањето ${list[i].id} е доделено на ${ime}.`,
    list[i].klientEmail
  );

  writeAll(list);
}

/* Часови */
export function setCasovi(id, casoviNum) {
  const list = readAll();
  const i = list.findIndex((x) => x.id === id);

  if (i === -1) return;

  list[i].casovi = Number(casoviNum || 0);
  list[i].history = list[i].history || [];

  list[i].history.push({
    action: "Ажурирани часови",
    date: new Date().toLocaleString("mk-MK"),
    details: `Внесени се ${casoviNum} работни часови.`,
  });

  writeAll(list);
}

/* Филтрирање */
export function filterBaranja({
  from = null,
  to = null,
  status = null,
  vraboten = null,
  korisnik = null,
} = {}) {
  const list = readAll();

  return list.filter((b) => {
    const d = new Date(b.datum.split(".").reverse().join("-"));

    const fromOk = !from || d >= new Date(from);
    const toOk = !to || d <= new Date(to);
    const statusOk = !status || b.status === status;
    const vrabotenOk = !vraboten || b.vraboten === vraboten;
    const korisnikOk = !korisnik || b.klientEmail === korisnik;

    return fromOk && toOk && statusOk && vrabotenOk && korisnikOk;
  });
}

/* Бришење */
export function izbrishiBaranje(id) {
  const list = readAll();
  const newList = list.filter((x) => x.id !== id);

  writeAll(newList);
}

export function izbrishiBaranjeSoIzvestuvanja(id) {
  const list = readAll();
  const updated = list.filter((x) => x.id !== id);

  writeAll(updated);

  const [serija, godina] = id.split("/");
  const reversed = `${godina}/${serija}`;

  const notifs = readNotifs();

  const cleaned = notifs.filter((n) => {
    const t = String(n.title || "");
    return !t.includes(id) && !t.includes(reversed);
  });

  writeNotifs(cleaned);
}

/* Статистика */
export function getStatistika() {
  const list = readAll();

  return {
    вкупно: list.length,
    отворени: list.filter((x) => x.status === "Отворено").length,
    воТек: list.filter((x) => x.status === "Во тек").length,
    завршени: list.filter((x) => x.status === "Завршено").length,
    откажани: list.filter((x) => x.status === "Откажано").length,
  };
}

/* Seed демо */
export function seedIfEmpty() {
  const list = readAll();

  if (!list.length) {
    const demo = {
      id: "001/2025",
      broj: "001/2025",
      datum: todayDate(),
      createdAtISO: new Date().toISOString(),
      naslov: "Демо барање",
      opis: "Ова е пример барање за тест.",
      stepen: 3,
      baratel: "Demo User",
      aplikacija: "Demo App",
      firma: "Demo Firma",
      tip: "Тест",
      prioritet: "Среден",
      status: "Отворено",
      klientEmail: "demo@megasoft.mk",
      vraboten: null,
      casovi: 0,
      notes: "",
      fazi: [],
      sliki: [],
      history: [
        {
          action: "Создадено барање",
          date: new Date().toLocaleString("mk-MK"),
          details: "Барањето е поднесено од demo@megasoft.mk.",
        },
      ],
    };

    writeAll([demo]);
  }
}

/* Reset бројачи */
export function resetYearCounters() {
  localStorage.removeItem(YEAR_KEY);
}